import { render, staticRenderFns } from "./BankImage.vue?vue&type=template&id=60647033"
import script from "./BankImage.vue?vue&type=script&lang=js"
export * from "./BankImage.vue?vue&type=script&lang=js"
import style0 from "./BankImage.vue?vue&type=style&index=0&id=60647033&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports